const styles = () => ({
  '.MuiDialog-container > .MuiPaper-root': {
    padding: '0 !important',
    borderRadius: '12px',
    maxWidth: '500px',
    minWidth: '300px',
  },

  '&.dn-expand': {
    '.MuiDialog-container > .MuiPaper-root': {
      maxWidth: '1200px',
      minWidth: '600px',
    },
  },

  '.MuiDialog-container': {
    background: 'rgba(29, 50, 153, 0.5)',
    backdropFilter: 'blur(3px)',
  },

  '.MuiDialogActions-root': {
    padding: '30px',
    paddingTop: '20px',
    marginTop: '-20px',
    marginLeft: 'auto',
    marginRight: 'auto',

    '&:empty': {
      margin: '0 !important',
      padding: '0 !important',
    },
  },

  '.MuiDialogContent-root': {
    overflowX: 'hidden',
    padding: '0 !important',

    '& > div': {
      padding: '30px 42.5px 42.5px 42.5px !important',

      '&:empty': {
        padding: '0 !important',
      },
    },
  },

  '.MuiDialogTitle-root': {
    padding: '15px 50px',
    display: 'flex',
    position: 'relative',
    background: '#F7F7F7',
    fontWeight: '400',
    fontSize: '19px',
    lineHeight: '20px',
    color: '#4D4D4D',
    minHeight: '25px',

    '&:empty': {
      margin: '0 !important',
      minHeight: '25px',
    },
  },

  '.dn-icon': {
    marginRight: '5px',
    display: 'flex !important',
    color: '#2845D2',
  },

  '.MuiButton-root + .MuiButton-root': {
    marginLeft: '10px',
  },

  '.dn-back-modal, .dn-close-modal': {
    zIndex: '10',
    position: 'absolute',
    top: '9.5px',
    right: '9.5px',
    padding: '10px',

    svg: {
      color: '#2845D2',
      height: '16px',
      width: '16px',
    },

    '&.dn-white svg': {
      color: '#fff',
    },

    '&:hover': {
      background: 'rgba(29, 50, 153, 0.08)',
    },
  },

  '.dn-back-modal': {
    left: '9.5px',
    right: 'auto',
  },

  '.MuiAlert-root': {
    padding: '15px 30px',
    background: 'rgba(255, 0, 0, 0.12)',
    borderRadius: '6px',

    '.MuiAlert-message': {
      fontSize: '14px',
      lineHeight: '18px',
      color: '#FF0000',
    },

    '.MuiAlert-icon': {
      color: '#FF0000',
      padding: '0 !important',
    },
  },

  '.dn-delete-api': {
    p: {
      fontSize: '16px !important',
      lineHeight: '20px',
      color: '#9B9B9B !important',

      '.MuiLink-root': {
        textDecoration: 'none',
        color: '#0176FF',

        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },

    '& + .dn-success-api': {
      marginTop: '25px',
    },
  },

  '.dn-success-api': {
    '.MuiAlert-root': {
      background: '#FFFADF',

      '.MuiAlert-message': {
        color: '#4B4B4B',
      },

      '.MuiAlert-icon': {
        color: '#FFDD26',
      },
    },

    '.MuiAlert-message': {
      padding: '0',
    },
  },

  '.dn-buttons': {
    marginTop: '30px !important',
  },

  '.dn-button-download': {
    textAlign: 'center',
    fontFamily: 'Inter',
    minHeight: '40px !important',
    lineHeight: '40px !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    width: '140px !important',
    borderRadius: '5px !important',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    color: '#fff !important',
    border: '1px solid #2845D2 !important',
    background: '#2845D2 !important',
    textDecoration: 'none !important',

    '&:hover': {
      backgroundColor: '#1431c2 !important',
      border: '1px solid #1431c2 !important',
      color: '#fff !important',
    },
  },

  '.Mui-disabled': {
    '.MuiChip-root': {
      '.MuiSvgIcon-root': {
        display: 'none',
      },
    },
  },

  '.MuiChip-root': {
    borderRadius: '5px !important',
    height: '25px',
    minWidth: '50px',
    fontSize: '12px',
    zIndex: '10',
    margin: '0 3.5px 0 0 !important',

    '&.Mui-disabled': {
      '.MuiSvgIcon-root': {
        display: 'none',
      },
    },

    '&.dn-success': {
      background: 'rgba(2, 175, 66, 0.08)',
      color: '#02AF42',
    },

    '&.dn-error': {
      background: 'rgba(234, 29, 37, 0.08)',
      color: '#EA1D25',
    },

    '&.dn-GET': {
      color: '#fff',
      background: '#61affe',
      borderRadius: '6px',
    },

    '&.dn-POST': {
      color: '#fff',
      background: '#49cc90',
      borderRadius: '6px',
    },

    '&.dn-PUT': {
      color: '#fff',
      background: '#fca130',
      borderRadius: '6px',
    },

    '&.dn-DELETE': {
      color: '#fff',
      background: '#f93e3e',
      borderRadius: '6px',
    },
  },

  '.dn-resend': {
    marginTop: '-10px',
    textAlign: 'center',
    color: '#B2B2B2',

    p: {
      fontSize: '12px !important',
      lineHeight: '16px !important',
    },

    a: {
      color: '#2845D2 !important',
      textDecoration: 'none',
      marginLeft: '5px',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

  '.dn-margin': {
    marginBottom: '15px !important',
  },

  '&.dn-expired': {
    '.MuiDialogContent-root': {
      paddingTop: '80px !important',
      paddingBottom: '80px !important',
      position: 'relative',
      zIndex: '99',

      '& > div:before': {
        content: "''",
        position: 'absolute',
        right: '0',
        top: '-60px',
        background: 'url(https://resources.datanomik.com/dashboard/images/expired-bg.svg) top right no-repeat',
        backgroundSize: 'contain',
        width: '100%',
        height: '370px',
        zIndex: '-1',
      },
    },

    h6: {
      fontWeight: '400',
      fontSize: '22px',
      lineHeight: '26px',
      color: '#4B4B4B !important',
      marginTop: '80px',
      marginBottom: '10px',
    },

    p: {
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '17px',
      color: '#7B7B7B',
      marginBottom: '30px',
    },
  },
});

export const scrollDialogStyles = () => ({
  '#id-table-grid': {
    height: 'auto !important',
    '.MuiDataGrid-virtualScroller': {
      maxHeight: '381px',
      overflowY: 'auto !important',
    },
    '.dn-table-subtotal': {
      position: 'sticky',
      bottom: '0',
    },
    '.MuiDataGrid-root > div:first-of-type': {
      display: 'none',
    },
    '.dn-table-row-danger': {
      '.MuiDataGrid-cellContent': {
        color: '#DC143C',
      },
    },
    '.MuiDataGrid-columnHeaders': {
      borderTop: 'none',
    },
  },
  '.dn-autocomplete': {
    marginTop: '0 !important',
    '.MuiInputLabel-root': {
      display: 'none',
    },
    input: {
      pointerEvents: 'none !important',
    },
  },
  '.MuiDialogTitle-root': {
    background: '#FFFFFF',
    border: '1px solid rgba(75, 75, 75, 0.1)',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.05)',
    '.dn-icon-button': {
      '.MuiButtonBase-root': {
        background: '#FFFFFF',
        color: '#2845D2',
        padding: '6px',
        position: 'relative',
        svg: {
          width: '18px',
          height: '18px',
          color: 'inherit',
          fontSize: '15px',
        },
        '&:hover': {
          background: 'rgba(40, 69, 210, 0.05)',
        },
      },
    },
  },
  '.MuiDialogContent-root': {
    border: 'none',
    padding: '32px 24px',
  },
  '.dn-title': {
    padding: '30px',
    p: {
      fontWeight: '700',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.17px',
      color: '#4B4B4B',
    },
    '&.dn-title-inactive': {
      p: {
        color: '#7B7B7B !important',
      },
    },
    '.dn-icon-button, .dn-copy-button': {
      '.MuiButtonBase-root': {
        background: '#FFFFFF',
        color: '#2845D2',
        padding: '6px',
        position: 'relative',
        border: '1px solid rgba(40, 69, 210, 0.3) !important',
        borderRadius: '5px',
        width: '30px',
        height: '30px',
        minWidth: '30px',
        svg: {
          width: '14px',
          height: '14px',
          color: 'inherit',
          fontSize: '15px',
        },
        '&:hover': {
          background: 'rgba(40, 69, 210, 0.05)',
        },
      },
      '& > * + *': {
        marginLeft: '5px',
      },
    },
    '.dn-copy-button': {
      marginLeft: '0',
    },
  },
  '.dn-balances': {
    padding: '15px 30px 15px 15px',
    marginTop: '-30px',
    position: 'relative',
  },
  '.apexcharts-toolbar': {
    display: 'none',
  },
  '.MuiAutocomplete-clearIndicator': {
    display: 'none',
  },
  '.dn-chart-donut': {
    padding: '15px 30px',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    width: 'calc(100% + 50px)',
    boxSizing: 'border-box',
    marginLeft: '-50px',

    '.apx-legend-position-right': {
      top: '50% !important',
      transform: 'translateY(-50%)',
      bottom: 'auto',
      maxHeight: '100%',
    },
  },
  '.apexcharts-tooltip': {
    fontFamily: "'Inter', sans-serif !important",
    background: '#FFFFFF !important',
    border: '1px solid rgba(40, 69, 210, 0.2) !important',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.05) !important',
    borderRadius: '5px !important',
    '& > div': {
      minWidth: '130px',
      '& > div': {
        background: 'rgba(40, 69, 210, 0.1)',
        borderRadius: '5px 5px 0px 0px',
        padding: '7px 9px',
        '& > h4': {
          fontWeight: '400',
          fontSize: '10px',
          lineHeight: '11px',
          color: '#2845D2',
          margin: 0,
        },
      },
      '& > p': {
        padding: '7px 9px',
        fontSize: '10px !important',
        lineHeight: '12px !important',
        color: '#2845D2 !important',
        margin: 0,
        '&.dn-negative': {
          color: '#DC143C !important',
        },
      },
    },
  },
  '.dn-donut-inactive': {
    svg: {
      pointerEvents: 'none',
    },
    '.apexcharts-legend-marker, .apexcharts-legend-text': {
      color: '#7B7B7B !important',
    },
  },
  '.apexcharts-legend-marker, .apexcharts-legend-text': {
    verticalAlign: 'middle',
    fontSize: '11px !important',
    lineHeight: '12px !important',
    color: '#4b4b4b !important',
    marginLeft: '5px',
    paddingLeft: '0',
  },
  '.apexcharts-legend-marker': {
    width: '7px !important',
    height: '7px !important',
    borderRadius: '500px !important',
    overflow: 'hidden',
  },
  '.dn-icon': {
    svg: {
      width: '18px',
      height: '18px',
      right: '5px !important',
      top: '6px !important',
      color: '#2845D2',
    },
    '.dn-input': {
      width: '100% !important',
      padding: '5px 23px 5px 5px',
      height: '30px !important',
      border: '1px solid rgba(40, 69, 210, 0.3) !important',
      fontSize: '11px !important',
    },
  },
  '.apexcharts-text': {
    fontFamily: "'Inter', sans-serif !important",
    fontSize: '10px',
    lineHeight: '11px',
    color: '#4B4B4B',
  },
  '.dn-overview-box-filters': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    '.dn-vl-field-wrapper': {
      width: '200px',
      marginRight: '5px',
    },
    '.MuiOutlinedInput-root': {
      backgroundColor: '#fff',
    },
    '.MuiInputLabel-root': {
      display: 'none',
    },
    input: {
      pointerEvents: 'none !important',
    },
  },

  '.dn-filter-button': {
    height: '36px',
    width: '36px',
    minWidth: 'auto !important',
    minHeight: 'auto !important',
    fontSize: '14px !important',
    lineHeight: '16px !important',
    border: '1px solid rgba(40, 69, 210, 0.2) !important',
    color: '#4B4B4B !important',
    fontWeight: '400 !important',
    marginLeft: '10px',
    svg: {
      color: '#2845D2 !important',
      width: '18px',
      height: '18px',
    },
  },
  '.dn-alert-refresh': {
    marginTop: '15px',
    width: 'auto',
    padding: '3px 8px',
    background: '#FFFADF',
    borderRadius: '5px!important',

    '.MuiAlert-message': {
      width: '100%',
      padding: '0',

      p: {
        fontWeight: '400',
        fontSize: '11px',
        lineHeight: '14px',
        color: '#4B4B4B',

        a: {
          marginLeft: '3px',
          textDecoration: 'none',
        },
      },
    },

    '.MuiAlert-icon': {
      marginRight: '5px',
      padding: '7.5px 0 !important',
      color: '#ff9800',

      svg: {
        height: '15px',
        width: '15px',
      },
    },
  },
  '.autocomplete-filter-category': {
    '.MuiInputBase-root': {
      paddingBottom: '3px !important',
      paddingLeft: '3px !important',
      paddingTop: '3px !important',
      minHeight: '30px !important',
    },
    '.MuiInputBase-input': {
      padding: '4px !important',
    },
    '.MuiChip-root': {
      '.MuiChip-label': {
        fontSize: '10px',
      },
      '.MuiSvgIcon-root': {
        width: '14px',
        height: '14px',
      },
    },
  },
});

export default styles;
